import React from 'react';
import { IoClose } from 'react-icons/io5';
import DashboardCharts from './DashboardCharts';
import './DashboardChartsDrawer.scss';

interface ChartSegment {
  label: string;
  count: number;
  filter: string;
}

interface ChartData {
  title: string;
  segments: ChartSegment[];
}

interface DashboardChartsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  chartsData?: ChartData[];
  onSliceClick?: (chartTitle: string, category: string, filter: string, isActive: boolean) => void;
    // NEW
  variant?: 'desktop' | 'mobile';
  activeChartFilter?: string | null;
}

const DashboardChartsDrawer: React.FC<DashboardChartsDrawerProps> = ({
  isOpen,
  onClose,
  chartsData,
  onSliceClick,
  variant = 'mobile',
  activeChartFilter = null,
}) => {
  if (!isOpen) return null;


    // Wrapper: on mobile close drawer after any slice click
  const handleSliceClick = (
    chartTitle: string,
    category: string,
    filter: string,
    isActive: boolean
  ) => {
    onSliceClick?.(chartTitle, category, filter, isActive);
    if (variant === 'mobile') {
      onClose();
    }
  };

  const getActiveCategoryForChart = (chartTitle: string): string | null => {
  if (!activeChartFilter) return null;

  const prefix = `${chartTitle}: `;
  if (!activeChartFilter.startsWith(prefix)) return null;

  return activeChartFilter.slice(prefix.length); // the category name
};




return (
    <>
      {/* Backdrop (opaque) */}
      <div
        className="charts-drawer__backdrop"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="charts-drawer__wrapper">
        <aside className="charts-drawer__panel">
          {/* Header */}
          <div className="charts-drawer__header">
            <h2 className="charts-drawer__title">Dashboard Charts</h2>
            <button
              onClick={onClose}
              className="charts-drawer__close"
              aria-label="Close charts drawer"
            >
              <IoClose size={22} />
            </button>
          </div>

          {/* Content */}
          <div className="charts-drawer__content">
            {/* <div className="charts-drawer__charts-wrapper"> */}
              {chartsData && chartsData.length > 0 ? (
                chartsData
                  .filter(chart => chart.segments.some(s => s.count > 0))
                  .map((chart, index) => (
                    <div key={`drawer-chart-${chart.title}-${index}`}>
        <DashboardCharts
          chartsData={[chart]}
          onSliceClick={handleSliceClick}
          variant={variant}
                  />
      </div>
                  ))
              ) : (
                <div className="charts-drawer__empty">No chart data available</div>
              )}
            {/* </div> */}
          </div>

          {/* Footer */}
          {/* <div className="charts-drawer__footer">
            <button
              onClick={onClose}
              className="charts-drawer__btn-close"
            >
              Close
            </button>
          </div> */}
        </aside>
      </div>
    </>
  );
};

export default DashboardChartsDrawer;